<template>
  <v-app-bar
    app
    absolute
    color="#eb4034"
    dark
    shrink-on-scroll
    :src="image"
    scroll-target="#scrolling-techniques-2"
  >
    <template v-slot:img="{ props }">
      <v-img
        v-bind="props"
        gradient="to top right, rgba(235,64,52,.5), rgba(122,32,26,.8)"
      ></v-img>
    </template>

    <v-toolbar-title>
      Cometa Motocenter
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
export default {
  name: 'CoreAppBar',

  data() {
    return {
      image: require('@/assets/images/moto.png')
    }
  }
}
</script>
